module.exports = __webpack_public_path__ + "img/testing-icon.91b947c2.svg";